module.exports = __webpack_public_path__ + "img/app2.a273383c.jpg";